var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiguresoftball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22.3242 28.1133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 28.1133,
    opacity: 0,
    width: 22.3242,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30859 10.2422C9.72656 10.2422 10.875 9.09375 10.875 7.67578C10.875 6.25781 9.72656 5.12109 8.30859 5.12109C6.89062 5.12109 5.75391 6.25781 5.75391 7.67578C5.75391 9.09375 6.89062 10.2422 8.30859 10.2422ZM2.07422 25.6406L9.11719 27.4102C10.1133 27.6562 10.7812 26.9297 10.6523 26.0039L9.99609 21.5156L15.5742 21.5156L19.9336 25.9336C20.3906 26.3906 21.1523 26.3906 21.6094 25.9336C22.1016 25.4766 22.0781 24.7031 21.6094 24.2344L17.0039 19.6055C16.6875 19.2891 16.5586 19.1953 16.0312 19.1367L10.9805 18.6328L9.70312 14.7773C9.60938 14.5078 9.82031 14.2383 10.1133 14.2969L19.3477 16.1367C19.9453 16.2539 20.6133 15.9375 20.7305 15.2227C20.8359 14.5781 20.4609 13.957 19.8164 13.8281L7.05469 11.2852C5.92969 11.0625 5.33203 10.8984 4.82812 10.4062L2.36719 7.96875L2.36719 2.51953C2.36719 1.86328 1.83984 1.33594 1.19531 1.33594C0.515625 1.33594 0 1.86328 0 2.51953L0 8.26172C0 8.75391 0.0585938 9.03516 0.410156 9.38672L3.15234 12.1172C3.71484 12.6914 3.78516 12.8906 3.98438 13.4648L7.6875 24.5977L2.64844 23.332C2.01562 23.168 1.37109 23.5664 1.23047 24.2109C1.08984 24.832 1.45312 25.4766 2.07422 25.6406ZM4.59375 2.92969C5.39062 2.92969 6.05859 2.28516 6.05859 1.46484C6.05859 0.65625 5.39062 0 4.59375 0C3.76172 0 3.14062 0.65625 3.14062 1.46484C3.14062 2.28516 3.76172 2.92969 4.59375 2.92969Z",
    fill: "currentColor",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiguresoftball);
export default __webpack_public_path__ + "static/media/figure.softball.c2019f5463ced899583913fdf4fe8eba.svg";
export { ForwardRef as ReactComponent };